import memoize from 'lodash.memoize';
import md5 from 'md5';
import { readCookie } from './cookies-browser';
import storage from './storage';
// import { GwResponseError } from '../actions/actionsFactory';

const getMd5Key = memoize(key => md5(key));

function getCr00Key() {
  const cr00 = readCookie('cr00');
  return cr00 && getMd5Key(cr00);
}

async function clientApiCache({
  key,
  expire = 60,
  getter,
  isExpiredFromResponse = false,
}) {
  const cr00Md5 = getCr00Key();
  if (cr00Md5) {
    const cachedVal = storage.getItem(`${cr00Md5}-${key}`);
    if (cachedVal) {
      return cachedVal;
    }
  }
  let response = {};
  try {
    response = await getter();
    if (!response.success) {
      // throw new GwResponseError(response.message);
      // TODO
      return response;
    }
    if (cr00Md5) {
      const expireTime = isExpiredFromResponse ? response.data : expire;
      if (expireTime === 0) return response;
      storage.setItem(`${cr00Md5}-${key}`, response, expireTime);
    }
  } catch (error) {
    throw error;
  }
  return response;
}

export default clientApiCache;
